import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=0c8bf514&scoped=true"
import script from "./Step2.vue?vue&type=script&lang=js"
export * from "./Step2.vue?vue&type=script&lang=js"
import style0 from "./Step2.vue?vue&type=style&index=0&id=0c8bf514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8bf514",
  null
  
)

export default component.exports